module.exports = __webpack_public_path__ + "prev.5b7161b0.png";